export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";